if (!customElements.get('arw-load-more')) {
  customElements.define('arw-load-more', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.closest('#ProductGridContainer')?.querySelector('#product-grid');
      this.next = this.querySelector('[data-load-next]');
      this.count = this.querySelector('[data-load-count]');
      this.error = this.querySelector('[data-load-error]');
      this.fallback = this.querySelector('[data-load-fallback]');
      if (!this.grid || !this.next || this.handleClick) return;
      this.handleClick = event => this.loadNext(event);
      this.next.addEventListener('click', this.handleClick);
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.next && this.handleClick) this.next.removeEventListener('click', this.handleClick);
      this.handleClick = null;
    }
    async loadNext(event) {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      if (this.busy) return;
      this.busy = true;
      this.controller = new AbortController();
      const currentLocation = window.location.pathname + window.location.search;
      const nextURL = new URL(this.next.href, window.location.origin);
      if (nextURL.origin !== window.location.origin) {
        this.busy = false;
        return;
      }
      nextURL.searchParams.set('section_id', this.dataset.sectionId);
      this.error.hidden = true;
      this.next.setAttribute('aria-disabled', 'true');
      this.next.setAttribute('aria-busy', 'true');
      this.next.textContent = this.dataset.loadingLabel;
      this.grid.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(nextURL, {signal: this.controller.signal, credentials: 'same-origin'});
        if (!response.ok) throw new Error('Load failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!this.isConnected || currentLocation !== window.location.pathname + window.location.search) return;
        const nextGrid = html.querySelector('#product-grid');
        const nextControl = html.querySelector('arw-load-more');
        if (!nextGrid || !nextControl || nextControl.dataset.sectionId !== this.dataset.sectionId) throw new Error('Grid missing');
        const existing = new Set(Array.from(this.grid.children, card => card.dataset.productId));
        const additions = Array.from(nextGrid.children).filter(card => card.dataset.productId && !existing.has(card.dataset.productId));
        if (!additions.length) throw new Error('No new products');
        additions.forEach(card => {
          card.querySelectorAll('.scroll-trigger').forEach(node => node.classList.add('scroll-trigger--cancel'));
          if (card.classList.contains('scroll-trigger')) card.classList.add('scroll-trigger--cancel');
        });
        this.grid.append(...additions);
        const remaining = nextControl.querySelector('[data-load-next]');
        if (remaining) {
          const href = remaining.getAttribute('href');
          this.next.setAttribute('href', href);
          if (this.fallback) this.fallback.setAttribute('href', href);
        } else {
          this.next.hidden = true;
        }
        const shown = this.grid.querySelectorAll(':scope > [data-product-id]').length;
        this.count.textContent = this.dataset.countTemplate.replace('__SHOWN__', shown).replace('__TOTAL__', this.dataset.total);
        additions[0].querySelector('h3 a, a')?.focus({preventScroll:true});
      } catch (error) {
        if (error.name !== 'AbortError' && this.isConnected) this.error.hidden = false;
      } finally {
        this.busy = false;
        this.grid.removeAttribute('aria-busy');
        this.next.removeAttribute('aria-busy');
        this.next.removeAttribute('aria-disabled');
        this.next.textContent = this.dataset.buttonLabel;
      }
    }
  });
}
